'use strict';

wbApp.factory('cacheSvc', [
    function () {
        var data = {};

        return {
            contains: function (key) {
                return !!data[key];
            },
            get: function (key) {
                return data[key];
            },
            insert: function (key, value) {
                data[key] = value;
            },
            remove: function (key) {
                delete data[key];
            },
            removeAll: function () {
                data = {};
            }
        }
    }]);